const InstrumentChartTypeEnum = {
  OPTIMAL_HEDGE_RATIO             : 'OptimalHedgeRatio',
  HEDGED_VS_UNHEDGED              : 'HedgedVSUnhedged',
  ROLLING_TRADE_VS_STRIP_OF_TRADES: 'RollingTradeVsStripOfTrades'
}
export default InstrumentChartTypeEnum
